// services/mengantar/status.ts — status konfigurasi Mengantar per-brand (via S2 proxy)
import { mengantarFetch } from './mengantar-auth';

export async function fetchBrandMengantarStatus(brandId: string, timeoutMs = 10000): Promise<{ configured: boolean; scope?: string }> {
  if (!brandId) return { configured: false };
  const ctrl = new AbortController();
  const timer = setTimeout(() => ctrl.abort(), timeoutMs);
  try {
    const res = await mengantarFetch(brandId, '/status', { signal: ctrl.signal });
    if (res.status === 404) return { configured: false };
    const json = await res.json().catch(() => null);
    return { configured: !!(json?.success && (json?.data as any)?.configured), scope: (json?.data as any)?.scope || undefined };
  } catch {
    return { configured: false };
  } finally {
    clearTimeout(timer);
  }
}
